const main = document.querySelector('main');
const isSup = main.getAttribute('data-blog') === 'sup';

mapboxgl.accessToken =
  'pk.eyJ1IjoiZWZmaWNpZW5jZXdlYiIsImEiOiJja25wd29hanUwMDdqMnZvN2tieXVhYzl5In0.hr2GjO45W302btN_rHdJrQ';

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v12',
  center: [-4.45925, 48.402],
  zoom: 12,
});

map.addControl(new mapboxgl.NavigationControl());

const markerUrl = '/wp-json/options/contact';

fetch(markerUrl)
  .then((response) => response.json())
  .then((data) => {
    if (isSup) data = data.slice(data.length - 2, data.length);

    data.forEach((element) => {
      const el = document.createElement('a');
      const img = document.createElement('img');
      const span = document.createElement('span');
      el.href = element.fiche_google_map;
      el.target = '_blank';
      span.style.background = `${element.couleur}`;
      img.src = element.logo;
      span.appendChild(img);
      el.appendChild(span);

      el.className = 'contact__marker';

      new mapboxgl.Marker(el)
        .setLngLat([element.longitude, element.latitude])
        .addTo(map);
    });
  });
